import { useI18n } from 'vue-i18n'
import DocumentArea = App.Enums.DocumentArea

const icons: Record<DocumentArea, string> = {
  profile: 'pi pi-id-card',
  credit: 'pi pi-chart-line',
  company: 'pi pi-building',
  estate_object: 'pi pi-warehouse',
}

export function useDocumentAreas() {
  const { t } = useI18n({ useScope: 'global' })

  return {
    areaLabel: (area: DocumentArea): string => t(`documentAreas.${area}`),
    areaIcon: (area: DocumentArea): string => icons[area],
  }
}
